import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';

const SECTION_ID = 'home-page-section-b';
const TEXT_1_CLASS = 'text-1';
const TEXT_2_CLASS = 'text-2';
const SMALL_TEXT_CLASS = 'small-text';
const VIDEO_OVERLAY_ID = 'video-overlay';
const MOBILE_ARROW_CLASS = 'mobile-arrow';
const PINNED_ELEMENT_CLASS = 'pinned';

class AnimationsHomeSectionB {
    constructor() {
        this._section = document.getElementById(SECTION_ID);
        this._section && this._run();
    }
    _run = () => {
        this._media = gsap.matchMedia();
        this._text1 = this._section.querySelector(`.${TEXT_1_CLASS}`);
        this._text2 = this._section.querySelector(`.${TEXT_2_CLASS}`);
        this._smallText = this._section.querySelector(`.${SMALL_TEXT_CLASS}`);
        this._videoOverlay = this._section.querySelector(`#${VIDEO_OVERLAY_ID}`);
        this._video = this._section.querySelector('video');
        this._mobileArrow = this._section.querySelector(`.${MOBILE_ARROW_CLASS}`);
        this._pinnedElement = this._section.querySelector(`.${PINNED_ELEMENT_CLASS}`);

        this._media.add(
            {
                isDesktop: `(min-width: ${screenSm}px)`,
                isMobile: `(max-width: ${screenSm - 1}px)`,
                reduceMotion: '(prefers-reduced-motion: reduce)',
            },
            this._createAnimationTimeline,
        );
    };
    _createAnimationTimeline = (context) => {
        let { isDesktop, isMobile, reduceMotion } = context.conditions;
        let easing = 'sliderEase';

        this._animation1 = gsap.timeline({
            scrollTrigger: {
                trigger: this._section,
                start: 'top top',
                end: 'bottom top',
                markers: false,
                // pin: this._pinnedElement,
                // anticipatePin: 1,
                onUpdate: ({ progress }) => {
                    if (progress === 0) {
                        this._video.currentTime = 0;
                    } else if (progress > 0.01 && progress < 1) {
                        this._video.play();
                    } else {
                        this._video.pause();
                    }
                    //this._video.currentTime = this._video.duration * progress;
                },
            },
        });

        this._animation1
            .to(this._videoOverlay, {
                keyframes: isDesktop
                    ? {
                          '2%': { opacity: 1 },
                          '30%': { clipPath: 'inset(0% -5%)' },
                      }
                    : {
                          '2%': { opacity: 1 },
                          '30%': { clipPath: 'inset(0% -10%)' },
                      },
                ease: easing,
            })
            .to(
                this._text1,
                {
                    keyframes: {
                        '24%': { y: '-40vh', scale: 2.1 },
                    },
                    ease: easing,
                },
                '<',
            )
            .to(
                this._text2,
                {
                    keyframes: {
                        '24%': { y: '40vh', scale: 2.1 },
                    },
                    ease: easing,
                },
                '<',
            )
            .to(
                this._smallText,
                {
                    keyframes: {
                        [isDesktop ? '8%' : '5%']: { opacity: 0 },
                    },
                    ease: easing,
                },
                '<',
            )
            .to(
                this._mobileArrow,
                {
                    keyframes: {
                        '10%': { opacity: 1 },
                        '15%': { opacity: 0 },
                    },
                    ease: easing,
                },
                '<',
            );
    };
}

const animationsHomeSectionB = new AnimationsHomeSectionB();
